<template>
  <span
    class="stamped-product-reviews-badge stamped-main-badge"
    :data-id="productId"
    :data-product-type="productType"
  ></span>
</template>

<script>
export default {
  name: 'ReviewsBadge',
  props: {
    productId: {
      type: Number,
      required: true,
    },
    productType: {
      type: String,
      default: null,
    },
  },
}
</script>
